<section class="main panel" [ngClass]="customClass">
  <header>
    <i class="fa-solid icon {{icon.iconType}}" [ngClass]="{'active': icon.isActive, 'no-icon': !icon.isActive}"></i>
    <div class="text-container">
      <p class="primary">{{ heading }}</p>
      <p class="secondary">{{ subHeading }}</p>
    </div>
    <button class="default-btn" *ngIf="headerButton.isActive" (click)="triggerHeaderButtonFunction()">{{ headerButton.buttonText }}</button>
  </header>

  <section class="content">
    <ng-content #content></ng-content>
  </section>

  <section class="no-data-overlay" *ngIf="noData">
    <svg class="radial-background" viewBox="0 0 480 198" fill="none">
      <mask id="mask0_20072_1792" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-211" width="480" height="480">
        <rect width="480" height="480" transform="translate(0 -211)" fill="url(#paint0_radial_20072_1792)"/>
      </mask>
      <g mask="url(#mask0_20072_1792)">
        <circle cx="240" cy="29" r="47.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="79.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="111.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="143.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="143.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="175.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="207.5" stroke="#EAECF0"/>
        <circle cx="240" cy="29" r="239.5" stroke="#EAECF0"/>
      </g>
      <defs>
        <radialGradient id="paint0_radial_20072_1792" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(240 240) rotate(90) scale(240 240)">
          <stop/>
          <stop offset="1" stop-opacity="0"/>
        </radialGradient>
      </defs>
    </svg>
    <div class="content">
      <i class="fa-solid fa-magnifying-glass"></i>
      <h3>{{ 'shared.panel.noData' | translate }}</h3>
      <p>{{ 'shared.panel.sorryNoData' | translate }}</p>
      <button class="default-btn" *ngIf="noDataButton.isActive" [routerLink]="noDataButton.buttonRoute">{{ noDataButton.buttonText | translate }}</button>
    </div>
  </section>

  <div class="button-container">
    <button class="default-btn show-all" *ngIf="seeAllIsActive"><i class="fa-solid fa-eye"></i>{{ 'shared.panel.seeAll' | translate }}</button>
  </div>
</section>
